module.exports = __webpack_public_path__ + "img/china_unicom_icon.4254f9ab.svg";